import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Button, DialogActions, Typography } from '@mui/material';
import React, { useState } from 'react';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import * as yup from 'yup';
import DefaultModal from '../../../../components/Modals/DefaultModal';
import SuccessModal from '../../../../components/Modals/SuccessModal';
import { Project } from '../../../../models/project';
import { managerService } from '../../../../services/managerService';
import CreateManagerForm from './CreateManagerForm';
import { string } from 'yup';
import { Manager } from '../../../../models/manager';

interface Props {
  modalData: { open: boolean; project?: Project };
  closeModal: () => void;
  onSuccess: () => void;
}

const createManagerSchema = yup.object({
  firstName: string().default('').required('First Name is required'),
  lastName: string().default('').required('Last Name is required'),
  email: string()
    .default('')
    .email('Primary Email must be a valid email')
    .required('Primary Email is required'),
  phoneNumber: string().default('')
});

type CreateManagerForm = yup.InferType<typeof createManagerSchema>;

const defaultValues = createManagerSchema.getDefault();

const CreateManager = (props: Props): JSX.Element => {
  const [modalData, setModalData] = useState<CreateManagerForm | undefined>(
    undefined
  );
  const [successModal, setSuccessModal] = useState<boolean>(false);
  const methods = useForm<CreateManagerForm>({
    resolver: yupResolver(createManagerSchema),
    defaultValues
  });

  const formSubmitHandler: SubmitHandler<CreateManagerForm> = (
    data: CreateManagerForm
  ) => {
    if (data) {
      const payload = {
        ...data
      } as unknown as Manager;
      payload.phoneNumber = String(data.phoneNumber);
      managerService.createManager(payload).then(() => {
        setModalData(payload);
        props.closeModal();
        setSuccessModal(true);
      });
    }
    methods.reset();
  };

  const handleSuccess = () => {
    setSuccessModal(false);
    props.onSuccess();
  };

  const handleClose = () => {
    props.closeModal();
    methods.reset();
  };

  return (
    <>
      <DefaultModal open={props.modalData.open} handleClose={handleClose}>
        <Box sx={{ px: 12, textAlign: 'center' }}>
          <Typography variant="h4" textAlign="center" color="grey.900" mb={2}>
            Add a new manager to your AllWork account
          </Typography>
          <Typography
            variant="inherit"
            textAlign="center"
            color="#645C5A"
            mb={3}
          >
            Fill in the fields below and an invitation will be sent to this user
            to join your company account on AllWork
          </Typography>
          <Box px={2}>
            <FormProvider {...methods}>
              <form
                id="managerForm"
                onSubmit={methods.handleSubmit(formSubmitHandler)}
              >
                <CreateManagerForm />
              </form>
            </FormProvider>
          </Box>
          <DialogActions sx={{ justifyContent: 'center', py: 3, mt: 3 }}>
            <Button onClick={handleClose} variant="outlined">
              Cancel
            </Button>
            <Button type="submit" form="managerForm">
              Send Credentials
            </Button>
          </DialogActions>
        </Box>
      </DefaultModal>
      <SuccessModal open={successModal} handleClose={handleSuccess}>
        <Box textAlign="center">
          <Typography>
            You have added&nbsp;
            <strong>{`${modalData?.firstName} ${modalData?.lastName}`}</strong>
            &nbsp;to your AllWork account.
          </Typography>
          <Typography>
            An email will be sent to them with their new login credentials.
          </Typography>
        </Box>
      </SuccessModal>
    </>
  );
};

export default CreateManager;
